"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./..");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Article = _ref => {
  let {
    children,
    text,
    postedOn,
    postedByEmail
  } = _ref;
  const postDateFormatted = postedOn ? postedOn.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }) : "";
  const mailToRef = "mailto:" + postedByEmail;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
    className: "post post-large blog-single-post border-0 m-0 p-0",
    children: [postDateFormatted.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "post-date ms-0",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "month",
        children: "Posted:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "day",
        children: postDateFormatted
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "post-content ms-0",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Heading, {
        level: "h2",
        children: text
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "post-meta",
        children: postedByEmail ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
            iconClass: "fas fa-envelope",
            href: mailToRef,
            children: postedByEmail
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col",
          children: children
        })
      })]
    })]
  });
};
Article.propTypes = {
  text: _propTypes.default.string.isRequired,
  postedOn: _propTypes.default.instanceOf(Date),
  postedByEmail: _propTypes.default.string
};
Article.defaultProps = {
  text: "New Article"
};
var _default = exports.default = Article;